module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block block-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "block-content p-0"
  }, [_c('table', {
    staticClass: "table table-borderless table-striped table-hover"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.shipping_costs), function(shipping_cost) {
    return _c('tr', {
      key: shipping_cost.id
    }, [_c('td', [_c('a', [_vm._v(_vm._s(shipping_cost.country))])]), _vm._v(" "), _c('td', [_c('a', [_vm._v(_vm._s(shipping_cost.sales_channel))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.letterboxPackages[shipping_cost.id]),
        expression: "letterboxPackages[shipping_cost.id]"
      }],
      ref: "input",
      refInFor: true,
      staticClass: "form-control",
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.letterboxPackages[shipping_cost.id])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.letterboxPackages, shipping_cost.id, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-noborder",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.updateShippingCostField(shipping_cost.id, 'letterbox_package', shipping_cost.sales_channel)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    })])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.smallPackages[shipping_cost.id]),
        expression: "smallPackages[shipping_cost.id]"
      }],
      ref: "input",
      refInFor: true,
      staticClass: "form-control",
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.smallPackages[shipping_cost.id])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.smallPackages, shipping_cost.id, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-noborder",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.updateShippingCostField(shipping_cost.id, 'small_package', shipping_cost.sales_channel)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    })])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.parcelPosts[shipping_cost.id]),
        expression: "parcelPosts[shipping_cost.id]"
      }],
      ref: "input",
      refInFor: true,
      staticClass: "form-control",
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.parcelPosts[shipping_cost.id])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.parcelPosts, shipping_cost.id, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-noborder",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.updateShippingCostField(shipping_cost.id, 'parcel_post', shipping_cost.sales_channel)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    })])])])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Verzendkosten inkoopprijs (excl. btw)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Land")]), _vm._v(" "), _c('th', [_vm._v("Verkoopkanaal")]), _vm._v(" "), _c('th', [_vm._v("Brievenbuspakket")]), _vm._v(" "), _c('th', [_vm._v("Kleinpakket")]), _vm._v(" "), _c('th', [_vm._v("Pakketpost")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-255efd98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/settings/ShippingCostTab.vue
// module id = 699
// module chunks = 1